<footer class="app-footer">
    <div class="footer-content">
        <div class="footer-company">
            <p class="footer-company-name">Yllw AB</p>
            <p class="footer-org-number">{{ 'LAYOUT.FOOTER.ORGNUMBER' | translate: { number: '559317-8584' } }}</p>
        </div>
        <div class="footer-links">
            <a href="mailto:info@yllw.com" class="footer-link">{{ 'LAYOUT.FOOTER.CONTACTEMAIL' | translate }}</a>
        </div>
    </div>
</footer>
